/* A raw request url makes a poor metric tag: every obfuscated key, numeric id, and query
   string becomes its own tag value, so cardinality grows with traffic rather than with the
   number of routes, and identifiers end up in metrics that are not meant to hold them.
   Collapsing identifier segments leaves one tag value per route shape. */

const NUMERIC_SEGMENT = /^\d+$/;
const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/* Obfuscated primary keys (`ObfuscatedPrimaryKeyMixin`) are Hashids output: at least eight
   alphanumerics from a mixed-case alphabet, so all but a vanishing share carry an uppercase
   letter or a digit. Static route segments are lowercase words, and the few that carry a
   digit (`v7`, `i18n`, `l10n`) are shorter than eight characters, so a long alphanumeric
   segment with an uppercase letter or digit is an identifier. */
const OBFUSCATED_KEY_SEGMENT = /^(?=[a-z0-9]*[A-Z0-9])[a-zA-Z0-9]{8,}$/;

const ORIGIN = /^[a-z][a-z0-9+.-]*:\/\/[^/]+/i;

const templateSegment = (segment: string): string => {
  if (NUMERIC_SEGMENT.test(segment)) return ':id';
  if (UUID_SEGMENT.test(segment)) return ':uuid';
  if (OBFUSCATED_KEY_SEGMENT.test(segment)) return ':opk';
  return segment;
};

const templateApiPath = (url: string): string => {
  const [withoutQuery] = url.split(/[?#]/);
  const origin = withoutQuery.match(ORIGIN)?.[0] || '';
  const path = withoutQuery.slice(origin.length);

  return `${origin}${path.split('/').map(templateSegment).join('/')}`;
};

export default templateApiPath;
